const actions = {
  REQUESTING: 'Invoice2WorkOrder/REQUESTING',
  RESPONSE_ERROR: 'Invoice2WorkOrder/RESPONSE_ERROR',

  FETCH_WORKORDERS_FILTER_FOR_EXISTING_INVOICE2_ITEM:
    'Invoice2WorkOrder/FETCH_FILTER_FOR_EXISTING_INVOICE2_ITEM',
  LIST_WORKORDER_FOR_EXISTING_INVOICE2_ITEM: 'Invoice2WorkOrder/LIST_FOR_EXISTING_INVOICE2_ITEM',

  DELETE_WORKORDERS_FROM_INVOICE2_ITEM: 'Invoice2WorkOrder/DELETE_FROM_INVOICE2_ITEM',
  DELETE_WORKORDERS_FROM_INVOICE2_ITEM_RECIEVED:
    'Invoice2WorkOrder/DELETE_FROM_INVOICE2_ITEM_RECIEVED',

  ADD_WORKORDERS_TO_INVOICE2_ITEM: 'INVOICE2/ADD_WORKORDERS_TO_INVOICE2_ITEM',
  ADD_WORKORDERS_TO_INVOICE2_ITEM_RECIEVED: 'INVOICE2/ADD_WORKORDERS_TO_INVOICE2_ITEM_RECIEVED',
}

export default actions
